import { de, enUS, es, fi, fr, it, Locale, nl, pt } from 'date-fns/locale';
import { t, TOptions } from 'i18next';

enum Language {
  ENGLISH = 'English',
  SPANISH = 'Spanish',
  FRENCH = 'French',
  ITALIAN = 'Italian',
  GERMAN = 'German',
  DUTCH = 'Dutch',
  PORTUGUESE = 'Portuguese',
  FINNISH = 'Finnish',
}

enum I18NextNS {
  TRANSLATION = 'translation',
}

export enum LocaleCode {
  EN = 'en-US',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  DE = 'de',
  NL = 'nl',
  PT = 'pt',
  FI = 'fi',
}

export const LanguageToLocale: Record<Language, Locale> = {
  [Language.ENGLISH]: enUS,
  [Language.SPANISH]: es,
  [Language.FRENCH]: fr,
  [Language.ITALIAN]: it,
  [Language.GERMAN]: de,
  [Language.DUTCH]: nl,
  [Language.PORTUGUESE]: pt,
  [Language.FINNISH]: fi,
};

export const LocaleCodeToLanguage: Record<LocaleCode, Language> = {
  [LocaleCode.EN]: Language.ENGLISH,
  [LocaleCode.ES]: Language.SPANISH,
  [LocaleCode.FR]: Language.FRENCH,
  [LocaleCode.IT]: Language.ITALIAN,
  [LocaleCode.DE]: Language.GERMAN,
  [LocaleCode.NL]: Language.DUTCH,
  [LocaleCode.PT]: Language.PORTUGUESE,
  [LocaleCode.FI]: Language.FINNISH,
};

export const pseudoizerLanguage = 'Uzbek';

export const LanguageToLocaleCode: Record<Language, LocaleCode> = {
  [Language.ENGLISH]: LocaleCode.EN,
  [Language.SPANISH]: LocaleCode.ES,
  [Language.FRENCH]: LocaleCode.FR,
  [Language.ITALIAN]: LocaleCode.IT,
  [Language.GERMAN]: LocaleCode.DE,
  [Language.DUTCH]: LocaleCode.NL,
  [Language.PORTUGUESE]: LocaleCode.PT,
  [Language.FINNISH]: LocaleCode.FI,
};

export const getLocaleCode = (language: Language): LocaleCode => {
  return LanguageToLocaleCode[language];
};

export const getLocale = (language: Language): Locale => {
  return LanguageToLocale[language];
};

const handleCommonT = <T = string>(key: string | string[]) =>
  t(`report.common.${key}`) as T;

const handleReportT = (
  key: string | string[],
  options?: Omit<TOptions, 'context'> & { context?: string | undefined },
) => t(`report.report.${key}`, options);

export const isProdEnv = import.meta.env.VITE_SENTRY_ENVIRONMENT.includes(
  'prod',
);

function handleNSI18Next() {
  return {
    handleCommonT,
    handleReportT,
    isProdEnv,
  };
}

export { handleNSI18Next, I18NextNS, Language };
